export default function redirectViaForm(url, data) {
  const form = document.createElement('form');
  form.action = url;
  form.method = 'POST';
  form.style.display = 'none';

  for (const [name, value] of Object.entries(data)) {
    const input = document.createElement('input');
    input.name = name;
    input.value = value;
    input.type = 'hidden';
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}
